import Modal from "components/DesignSystem/Modal/Modal";
import { FormikForm } from "components/FormikForm/FormikForm";
import {
  buildEtdMessage,
  EtdUpdateForm,
} from "components/Ticket/EtdUpdateForm";
import { YYYY_MM_DD } from "constants/date";
import dayjs from "dayjs";
import { FormikValues } from "formik";
import {
  etdSetSchema,
  ticketETDUpdateSchema,
} from "formValidations/ticketSchema";
import { useRoleBasedView } from "hooks/useRoleBasedView";
import { useToast } from "hooks/useToast";
import {
  useUpdateTaskAssigneeAdminMutation,
  useUpdateTaskAssigneeProviderMutation,
} from "store/apis/serviceTeam";
import { Task } from "types/Models/task";
import { BackendError } from "types/utils/error";

export const ETDUpdateReason = ({
  isOpen,
  close,
  selectedDate,
  taskId,
  task,
}: {
  isOpen: boolean;
  close: () => void;
  selectedDate?: string;
  taskId: string;
  task: Task;
}) => {
  const { alertToast, successToast } = useToast();
  const [updateTaskDeliveryTimeAdmin, { isLoading }] =
    useUpdateTaskAssigneeAdminMutation();
  const [updateTaskDeliveryTime, { isLoading: isUpdatingDeliveryTime }] =
    useUpdateTaskAssigneeProviderMutation();
  const { isAdmin } = useRoleBasedView();
  const isUpdating = isLoading || isUpdatingDeliveryTime;

  let updateTaskAssignee = isAdmin
    ? updateTaskDeliveryTimeAdmin
    : updateTaskDeliveryTime;

  const handleSubmit = async (values: FormikValues) => {
    try {
      const { estimatedDeliveryTime, reason, message } = values;
      const etdTime = dayjs(estimatedDeliveryTime).format(YYYY_MM_DD);

      await updateTaskAssignee({
        taskId,
        estimatedDeliveryTime: etdTime,
        reason,
        customer_acr: message,
      }).unwrap();

      successToast({ message: "ETD set successfully" });
      close();
    } catch (error) {
      alertToast({
        message: (error as BackendError)?.data?.error?.message,
      });
    }
  };

  return (
    <Modal.Root open={isOpen} onOpenChange={close}>
      <Modal.Content>
        <FormikForm
          initialValues={{
            estimatedDeliveryTime: selectedDate,
            reason: "",
            message: buildEtdMessage(
              selectedDate,
              task.estimated_time_of_delivery?.date,
              task.title
            ),
          }}
          onSubmit={handleSubmit}
          validationSchema={
            task.estimated_time_of_delivery?.date
              ? ticketETDUpdateSchema
              : etdSetSchema
          }
          validateOnChange
        >
          <EtdUpdateForm
            isAdding={isUpdating}
            currentEtd={task.estimated_time_of_delivery?.date}
            filingName={task.title}
          />
        </FormikForm>
      </Modal.Content>
    </Modal.Root>
  );
};
